import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail } = FiIcons;

const Footer = () => {
  const handleEmailClick = () => {
    const email = 'info' + '@' + 'alphadrivinguk.com';
    window.location.href = `mailto:${email}`;
  };

  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-white py-12 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <motion.div className="flex items-center space-x-3 mb-4" whileHover={{ scale: 1.05 }}>
              <div className="w-10 h-10 rounded-full flex items-center justify-center overflow-hidden">
                <img
                  src="/alpha-logo.png"
                  alt="Alpha Driving School Logo"
                  className="w-full h-full object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div
                  className="w-10 h-10 bg-gradient-to-br from-[#2fc468] to-[#2fc468] rounded-full flex items-center justify-center"
                  style={{ display: 'none' }}
                >
                  <span className="text-white font-bold text-lg">A</span>
                </div>
              </div>
              <div>
                <span className="text-[#2fc468] font-bold text-xl">Alpha</span>
                <span className="text-gray-400 dark:text-gray-500 text-sm block leading-tight transition-colors">Driving School</span>
              </div>
            </motion.div>
            <p className="text-gray-400 dark:text-gray-500 mb-4 transition-colors">
              Your trusted partner for safe and confident driving in Greater London.
            </p>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Info</h3>
            <div className="space-y-2">
              <motion.button
                onClick={handleEmailClick}
                className="flex items-center gap-2 text-gray-400 dark:text-gray-500 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded px-2 py-1"
                aria-label="Click to email us"
              >
                <SafeIcon icon={FiMail} className="w-4 h-4" />
                <span>Click to Email Us</span>
              </motion.button>
            </div>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <motion.a
                href="https://www.facebook.com/profile.php?id=61573065712977"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-500 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded p-1"
                whileHover={{ scale: 1.2 }}
                aria-label="Visit our Facebook page"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className="w-6 h-6 fill-current">
                  <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/>
                </svg>
              </motion.a>
            </div>
            <p className="text-gray-400 dark:text-gray-500 text-sm mt-4 transition-colors">
              Partnership with Gill's Autos for car servicing
            </p>
          </div>
        </div>
        <div className="border-t border-gray-800 dark:border-gray-700 mt-8 pt-8 text-center transition-colors">
          <p className="text-gray-400 dark:text-gray-500 text-sm transition-colors">
            © 2025 Alpha Driving School. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;